import { IThrottleConfig } from "./throttleConfig.types"

export class ThrottleConfig implements IThrottleConfig {
  id: number
  communicationId: number
  communicationName: string
  maxPerWindow: number
  windowSeconds: number
  enabled: boolean

  constructor(
    id: number,
    communicationId: number,
    communicationName: string,
    maxPerWindow: number,
    windowSeconds: number,
    enabled: boolean,
  ) {
    this.id = id
    this.communicationId = communicationId
    this.communicationName = communicationName
    this.maxPerWindow = maxPerWindow
    this.windowSeconds = windowSeconds
    this.enabled = enabled
  }
}
